import React from 'react';
import { Sparkles } from 'lucide-react';

const BookSlider = () => {
  const books = [
    {
      id: 1,
      image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/td915y3y_Book%20%281%29.png',
      title: 'Book 1'
    },
    {
      id: 2,
      image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/4mj1ohl7_Book%20%282%29.png',
      title: 'Book 2'
    },
    {
      id: 3,
      image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/etg086g8_Book%20%283%29.png',
      title: 'Book 3'
    },
    {
      id: 4,
      image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/pgenpsmc_Book%20%284%29.png',
      title: 'Book 4'
    },
    {
      id: 5,
      image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/vlkjrpi7_Book%20%285%29.png',
      title: 'Book 5'
    },
    {
      id: 6,
      image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/p53nuut1_Book%20%286%29.png',
      title: 'Book 6'
    },
    {
      id: 7,
      image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/5ujogy5x_Book%20%287%29.png',
      title: 'Book 7'
    }
  ];

  // Duplicate books array twice for seamless infinite scroll
  const allBooks = [...books, ...books];

  return (
    <div className="w-full bg-white border-t-2 border-gray-200">
      <div className="flex items-stretch">
        {/* Left Side - Fixed Box with Label (Rounded Corner on Right) - Starts from left edge */}
        <div className="flex-shrink-0 bg-white flex items-center justify-center pr-4 md:pr-8 py-6 md:py-8 min-w-[200px] md:min-w-[280px] lg:min-w-[320px] relative shadow-lg rounded-br-[60px] md:rounded-br-[80px]" style={{ paddingLeft: 'max(1rem, calc(1rem + ((100vw - 1280px) / 2)))' }}>
          <div className="text-center relative z-10">
            <Sparkles className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 text-amber-700 mx-auto mb-2 md:mb-3 lg:mb-4" />
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
              Best Selling<br />Books
            </p>
          </div>
        </div>

        {/* Right Side - Scrolling Books */}
        <div className="flex-1 overflow-hidden relative py-4 md:py-6">
          {/* Gradient overlay on right edge for fade effect */}
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>

          <div className="flex animate-scroll-fast gap-4 md:gap-6 pl-2 md:pl-4">
            {allBooks.map((book, index) => (
              <div
                key={`${book.id}-${index}`}
                className="flex-shrink-0 book-item"
              >
                <img
                  src={book.image}
                  alt={book.title}
                  className="h-40 md:h-52 lg:h-64 w-auto object-contain transition-transform duration-300 hover:scale-110 hover:-rotate-6 cursor-pointer"
                  style={{ 
                    filter: 'drop-shadow(0 10px 25px rgba(0, 0, 0, 0.3))'
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll-smooth {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll-fast {
          animation: scroll-smooth 30s linear infinite;
          width: fit-content;
        }

        .animate-scroll-fast:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default BookSlider;
